import * as React from 'react';
import { SVGProps } from 'react';

const IconArtBrushSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8.633 15.436c-.666-.665-1.785-.913-2.805-.484-.903.406-1.495 1.189-1.71 2.247C3.795 18.773 3 20.5 2 21c2 .5 5 .5 6.809-1.877.72-.947.852-2.662-.176-3.687zM21 3c-1-.996-6.644 3.644-9.5 6.5-1.5 1.5-3 3.5-3 3.5.974.273 2.228 1.527 2.5 2.5 0 0 2-1.5 3.5-3C17.356 9.644 22 3.996 21 3z" />
  </svg>
);
export default IconArtBrushSizeM;
